import type { InventorySlot } from "@ghostland/shared";

export interface FridgeState {
  buildingId: string;
  slots: InventorySlot[];
  capacity: number; // in kg (every item is 1kg)
}

type Listener = (s: FridgeState) => void;

/**
 * Client mirror of a building's shared STAFF FRIDGE (store inventory). Fed by the server's targeted
 * `Fridge` messages (sent only to staff). The fridge panel subscribes; the server is authoritative.
 */
class FridgeStore {
  private state: FridgeState = { buildingId: "", slots: [], capacity: 0 };
  private readonly listeners = new Set<Listener>();

  get(): FridgeState { return this.state; }

  set(s: FridgeState): void {
    this.state = s;
    for (const fn of this.listeners) fn(this.state);
  }

  subscribe(fn: Listener): () => void {
    this.listeners.add(fn);
    fn(this.state);
    return () => this.listeners.delete(fn);
  }
}

export const fridgeStore = new FridgeStore();
